// var ga = window.ga;
var gtag = window.gtag;

document.addEventListener('ga:ready', function(){

  console.log('GA Ready');
  // ga = window.ga;
  // gtag = window.gtag;

});

document.querySelectorAll('div[data-ga="event"], a[data-ga="event"], button[data-ga="event"]').forEach(function(item){

  item.addEventListener('click', function(){

    var eventCategory = item.getAttribute('data-ga-event-category');
    var eventAction = item.getAttribute('data-ga-event-action');
    var eventLabel = item.getAttribute('data-ga-event-label');

    sendEvent({
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      // callback: function(){
      //   if($this.attr('target') == '_blank'){
      //     window.open($this.attr('href'), '_blank');
      //   } else {
      //     window.location = $this.attr('href');
      //   }
      // }
    });

  });

});

document.querySelectorAll('select[data-ga="event"]').forEach(function(item){

  item.addEventListener('change', function(){

    var eventCategory = item.getAttribute('data-ga-event-category');
    var eventAction = item.getAttribute('data-ga-event-action');
    var eventLabelPrefix = item.getAttribute('data-ga-event-prefix-label');
    var eventLabel = eventLabelPrefix+item.options[item.selectedIndex].text;

    sendEvent({
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      // callback: function(){
      //   if($this.attr('target') == '_blank'){
      //     window.open($this.attr('href'), '_blank');
      //   } else {
      //     window.location = $this.attr('href');
      //   }
      // }
    });

  });

});

function sendEvent(object){

  if(object.eventCategory != undefined && object.eventAction != undefined && object.eventLabel != undefined){

    console.log('ga event');
    console.log(object);
    
    gtag('event', object.eventAction, {
      event_category: object.eventCategory,
      event_label: object.eventLabel,
      event_callback: function(){
        if(typeof object.callback === 'function'){
          object.callback();
        }        
      },
    });

  }

}



//////////////////
// WEBPACK FOOTER
// ./scripts/autoload/_ga_event.js.old
// module id = 100
// module chunks = 0